const de = {
    '/': {
        title: '{brand} | Sportwetten, Live-Casino & Sofortauszahlungen',
        description: 'Spielautomaten, Live-Casino & Sportwetten bei {brand}. Krypto-Casino mit Sofortauszahlungen, nachweislich fairen Spielen & 24/7-Support.'
    },
    '/casino': {
        title: 'Online Casino | Slots, Blackjack & Live-Dealer | {brand}',
        description: 'Slots, Blackjack, Roulette & Live-Dealer bei {brand}. Hunderte Spiele, schnelle Krypto-Einzahlungen & Sofortauszahlungen rund um die Uhr.'
    },
    '/sports': {
        title: 'Online-Sportwetten | Krypto-Wetten & Quoten | {brand}',
        description: 'Sportwetten bei {brand}. Attraktive Quoten auf Fußball, Basketball & mehr. Live-Wetten, sichere Krypto-Einsätze & schnelle Auszahlungen.'
    },
    '/livecasino': {
        title: 'Live-Casino | Blackjack, Roulette & Live-Dealer | {brand}',
        description: 'Blackjack, Roulette & Live-Casino-Spiele bei {brand}. Echte Dealer, HD-Streaming & eine große Auswahl an Live-Tischen rund um die Uhr.'
    },
    '/slots': {
        title: 'Online-Slots | Riesige Auswahl an Casino-Slots | {brand}',
        description: 'Eine riesige Sammlung von Slots bei {brand}. Klassische Automaten, Video-Slots & Progressive-Jackpots – alle mit Krypto spielbar.'
    },
    '/vip': {
        title: 'VIP-Programm | Exklusive Belohnungen & Vorteile | {brand}',
        description: 'Das VIP-Programm von {brand}: exklusive Belohnungen, personalisierte Boni und priorisierter Support. Vorteile für treue Spieler.'
    },
    '/welcome-offer': {
        title: 'Willkommensbonus | Krypto Casino | {brand}',
        description: 'Entdecken Sie das Willkommensangebot von {brand}. Starten Sie mit Krypto und genießen Sie exklusive Boni für neue Spieler.'
    },
    '/referral': {
        title: 'Empfehlungsprogramm | Belohnungen Verdienen | {brand}',
        description: 'Laden Sie Freunde zu {brand} ein und verdienen Sie Belohnungen, wenn diese mitmachen und die Bedingungen erfüllen.'
    },
    '/promotion-page': {
        title: 'Aktionen | Boni & Sonderangebote | {brand}',
        description: 'Alle aktiven Aktionen bei {brand}. Boni, Freispiele und Sonderangebote für Krypto-Spieler.'
    },
    '/hotslots': {
        title: 'Hot Slots | Beliebteste Casino-Slots | {brand}',
        description: 'Spielen Sie die beliebtesten Slot-Spiele bei {brand}. Die heißesten Slots sind mit Krypto verfügbar.'
    },
    '/newgames': {
        title: 'Neue Spiele | Neueste Casino-Spiele | {brand}',
        description: 'Entdecken Sie die neuesten Casino-Spiele bei {brand}. Neue Slots, Live-Spiele und Tischspiele erscheinen regelmäßig.'
    },
    '/populargames': {
        title: 'Beliebte Spiele | Top Casino-Spiele | {brand}',
        description: 'Die beliebtesten Casino-Spiele bei {brand}. Von Slots bis Live-Spiele – alles mit Krypto verfügbar.'
    },
    '/gameshows': {
        title: 'Game Shows | Casino mit Live-Shows | {brand}',
        description: 'Genießen Sie Live-Game-Shows bei {brand}. Echte Moderatoren, einzigartige Spiele und große Gewinne in Echtzeit.'
    },
    '/table_games': {
        title: 'Tischspiele | Blackjack, Roulette & Baccarat | {brand}',
        description: 'Spielen Sie Blackjack, Roulette, Baccarat und weitere Tischspiele bei {brand}. Alles mit Krypto verfügbar.'
    },
    '/hotlive': {
        title: 'Beliebtes Live-Casino | Top Live-Casino-Spiele | {brand}',
        description: 'Die beliebtesten Live-Casino-Spiele bei {brand}. Spielen Sie mit echten Dealern in Echtzeit.'
    },
    '/featurebuyin': {
        title: 'Slots mit Bonus-Kauf | Feature Buy-in | {brand}',
        description: 'Spielen Sie Slots mit der Möglichkeit, die Bonusrunde bei {brand} zu kaufen. Direkt in die Bonusrunde ohne Warten.'
    }
};
export default de;
